export default __webpack_public_path__ + "static/media/clock_image.dec7e129.svg";